import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import Resource from "../resource";
import { PageRowSettings } from "./page-row-settings";
import { PortalColumnResource } from "./portal-column-resource";

@JsonObject()
export class PortalRowResource extends Resource {
    @JsonProperty("settings")
    settings: PageRowSettings;

    @JsonProperty("columns")
    @JsonElementType(PortalColumnResource)
    columns: Array<PortalColumnResource> = [];
}
